import React, {Component} from 'react';
import styles from 'css/components/button.css';
import {Link} from 'react-router-dom';


/**
 * Basic Button
 */
export class BasicButton extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const {
      className = null,
      href = null,
      onClick = null,
      target = null,
    } = this.props || {};

    const attributes = {
      className: styles.basic,
    };

    if (className) {
      attributes.className += ` ${className || ''}`;
    }

    if (href) {
      attributes.href = href;
    }

    if (target) {
      attributes.target = target;
    }

    if (onClick) {
      attributes.onClick = onClick;
    }

    return (
      <a {...attributes}>
        {this.props.children || ''}
      </a>
    );
  }
}


/**
 * Page Link Button
 */
export class PageLinkButton extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const {
      className = null,
      to = null,
    } = this.props || {};

    const attributes = {
      className: styles.link,
    };

    if (className) {
      attributes.className += ` ${className || ''}`;
    }

    if (to) {
      attributes.to = to;
    }

    return (
      <Link {...attributes}>
        {this.props.children || ''}
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/button/index.js